export const baseUrl = process.env.REACT_APP_API_BASE_URL;
export const customer_consent_valid_url = `${baseUrl}/customer-consent/v1/verifyURL`;
export const customer_consent_get_customer_profile = `${baseUrl}/customer-consent/v1/get`;
export const customer_consent_get_inspection_repair = `${baseUrl}/inspection/submitted-response/v1/get-responses`;
export const customer_consent_verify_otp = `${baseUrl}/customer-consent/v1/verify-otp`;
export const customer_agreement_get_lead_profile = `${baseUrl}/customer-consent/v1/get/agreement/profile`;
export const customer_agreement_details = `${baseUrl}/customer-consent/v1/get/agreement-details`;
export const customer_agreement_verify_otp = `${baseUrl}/customer-consent/v1/verify/agreement`;
export const customer_requirement = `${baseUrl}/vehicle/v1/get-customer-requirements`;
export const customer_details = (
  vehicleProfileId: string,
  typeMasterId: string,
) =>
  `${baseUrl}/customer-consent/v1/get-customer-report/${vehicleProfileId}/${typeMasterId}`;

export const customer_agreement_get_customer_report = (
  vehicleProfileId: string,
  typeMasterId: string,
) =>
  `${baseUrl}/inspection/submitted-response/v1/get-vehicle-report/${vehicleProfileId}/${typeMasterId}`;

export const customer_feedback = (leadId: string) =>
  `${baseUrl}/customer/v2/add/customerFeedback/${leadId}`;

export const view_service_estimate = (jobCardNo: string) =>
  `serviceV2/publicviewEstimate/${jobCardNo}`;

export const verify_service_estimate = (ticketNo: string) =>
  `serviceV2/publicverifyEstimate/${ticketNo}`;

export const create_service_feedback = (ticketNo: string) =>
  `serviceV2/createFeedback/${ticketNo}`;
